import React, { useState, useEffect } from "react";
import Banner from "./Banner";
import Topnav from "../common/Topnav";
import Programs from "./Programs";
import AboutSec from "./AboutSec";
import AlumniSec from "./AlumniSec";
import Awards from "./Awards";
import Placement from "./Placement";
import Recruiter from "./Recruiters";
import Sports from "./Sports";
import Events from "./Events";
import Footer from "../common/Footer";
import News from "./News.js";
import NewsLetter from "./NewsLetter.js";
import Accred from "./Accred";
import BannerMob from "./BannerMob";
import Blogs from "./Blogs";
import CourseFinder from "./CourseFinderHome";

const Home = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1000);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 1000);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // JSON-LD Schema
  const schemaData = {
    "@context": "https://schema.org",
    "@type": "CollegeOrUniversity",
    "@id": "https://isbmuniversity.edu.in/",
    "name": "ISBM University Chhattisgarh",
    "foundingDate": "2016",
    "description":
      "ISBM University, Chhattisgarh offers UGC-approved UG, PG & PhD programs. Recognized as a top university for quality education & career success.",
    "logo":
      "https://www.isbmuniversity.ac.in/assets/Images/logo/isbm-university.png",
    "sameAs": [
      "https://www.facebook.com/isbmuniversity/",
      "https://instagram.com/isbm_university",
      "https://twitter.com/ISBMUniversity",
      "https://www.linkedin.com/school/13211303/",
      "https://www.youtube.com/c/ISBMUniversity"
    ],
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "ISBM University, Ring Road No. 1",
      "addressLocality": "Tatibandh, Raipur",
      "addressRegion": "Chhattisgarh",
      "postalCode": "492099",
      "addressCountry": "IN"
    },
    "telephone": "+91-9373199999",
    "email": "info@isbmuniversity.edu.in",
    "contactPoint": [
      {
        "@type": "ContactPoint",
        "contactType": "Admissions",
        "telephone": "+91-9373199999",
        "email": "enquiry@isbmuniversity.edu.in",
        "availableLanguage": ["en", "hi"]
      }
    ],
    "department": [
      {
        "@type": "EducationalOrganization",
        "name": "ISBM University Chhattisgarh",
        "url": "https://isbmuniversity.edu.in/"
      }
    ],
    "knowsAbout": [
      "Management",
      "Engineering",
      "Commerce",
      "Law",
      "Science",
      "Arts & Humanities",
      "Pharmacy",
      "Library & Information Science",
      "NAAC Accreditation",
      "Ph.D. Research"
    ],
    "areaServed": {
      "@type": "Country",
      "name": "India"
    },
    "potentialAction": {
      "@type": "ApplyAction",
      "name": "Apply Online",
      "target": "https://isbmuniversity.edu.in/apply-online"
    }
  };

  // Inject into <head>
  useEffect(() => {
    // Title
    document.title = "ISBM University Chhattisgarh | Top University in India";

    // Canonical link
    let link = document.querySelector("link[rel='canonical']");
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", "https://isbmuniversity.edu.in");

    // Schema script
    let script = document.querySelector("script[data-schema='true']");
    if (script) {
      script.innerHTML = JSON.stringify(schemaData);
    } else {
      script = document.createElement("script");
      script.setAttribute("type", "application/ld+json");
      script.setAttribute("data-schema", "true");
      script.innerHTML = JSON.stringify(schemaData);
      document.head.appendChild(script);
    }
  }, []);

  return (
    <>
      {isMobile ? <BannerMob /> : <Banner />}
      <CourseFinder />
      <AboutSec />
      <Programs />
      <AlumniSec />
      <Awards />
      <Placement />
      <Recruiter />
      <Accred />
      <Sports />
      {/* <Events /> */}
      {/* <News /> */}
      <NewsLetter />
      {/* <Blogs /> */}
      <Footer />
    </>
  );
};

export default Home;
